import { render, staticRenderFns } from "./SubjectPageCustom.vue?vue&type=template&id=2786b2bb&"
import script from "./SubjectPageCustom.vue?vue&type=script&lang=js&"
export * from "./SubjectPageCustom.vue?vue&type=script&lang=js&"
import style0 from "./SubjectPageCustom.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports